import logo from './logo.svg';
import './App.css';
import Navbar from './components/layout/Navbar';
import Hero from './components/ui/Hero';
import Categories from './components/ui/Categories';
import Portfolio from './components/ui/Portfolio';
import Process from './components/ui/Process';
import FeaturedVideo from './components/ui/FeaturedVideo';
import Testimonials from './components/ui/Testimonials';
import Booking from './components/ui/Booking';
import Footer from './components/ui/Footer';
function App() {
  return (
    <div >
 <Navbar/>
 <Hero/>
 <Categories/>
 <Portfolio/>
 <Process/>
 <FeaturedVideo/>
 <Testimonials/>
 <Booking/>
 <Footer/>
    </div>
  );
}

export default App;
